<template>
    <div class="usermanager">
        <div class="centerStructure">
            <div class="searchBox">
                <span>关键字：</span>
                <el-input class="cname" clearable v-model.trim="keyword" placeholder="用户名或姓名"></el-input>
                <span class="inp">角色：</span>
                <el-select class="cname" v-model="roleId" placeholder="请选择角色">
                    <el-option style="width: 140px"
                               v-for="item in roleList"
                               :key="item.id"
                               :label="item.roleName"
                               :value="item.id"
                    >
                    </el-option>
                </el-select>
                <span class="inp">状态：</span>
                <el-select class="cname" v-model="status" placeholder="请选择状态">
                    <el-option style="width: 140px"
                               v-for="item in statusList"
                               :key="item.id"
                               :label="item.dictionaryName"
                               :value="item.id">
                    </el-option>
                </el-select>
                <span class="inp">部门：</span>
                <select-tree ref="assInnerTree"
                             :treeEdit="false"
                             :strictly="false"
                             node-key="id"
                             width="200px"
                             :nodeId="rootNode"
                             :sourceData="treeBaseData"
                             :formatTreeData="innerJsonTree"
                             :clearable="true"
                             @getValueMethod="clickAssInnerTree"
                             @clearMethod="onClear">
                </select-tree>
                <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
                <el-button type="primary" @click="toSave" v-if="$root.$permissionMap.has('insertUser')"
                           icon="el-icon-circle-plus-outline">添加
                </el-button>
            </div>
            <el-table
                    :data="tableData"
                    border
                    ref="singleTable"
                    style="width: 100%"
                    height="calc(100% - 84px)">
                <el-table-column
                        header-align="center"
                        align="center"
                        type="index"
                        width="50">
                </el-table-column>

                <template v-for="item in tableTitle">
                    <el-table-column v-if="item.prop == 'operation'" :label="item.label" :key="item.prop"
                                     header-align="center" align="center" :width="item.width">
                        <template slot-scope="scope">
                            <span class="tableicon" v-if="$root.$permissionMap.has('updateUser')"><i
                                    @click="toModify(scope)" class="el-icon-edit"></i></span>
                            <span class="tableicon" v-if="$root.$permissionMap.has('deleteUser')"><i @click="del(scope)"
                                                                                                     class="el-icon-delete"></i></span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :align="item.align"
                            header-align="center"
                            :key="item.index"
                            :label="item.label"
                            :prop="item.prop"
                            :width="item.width"
                            v-if="item.prop != 'operation'"
                            show-overflow-tooltip>
                    </el-table-column>
                </template>
            </el-table>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNumber"
                    :page-sizes="[20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pagetotal">
            </el-pagination>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="opendiaflag"
                :close-on-click-modal="false"
                :modal-append-to-body="false"
                width="680px">
            <div class="formbox">
                <el-form
                        :rules="rules"
                        :label-position="labelPosition"
                        :model="userDetail"
                        label-width="90px"
                        ref="ruleForm">
                    <div class="inline" style="display:flex">
                        <el-form-item label="用户名：" prop="loginName">
                            <el-input class="wh200" v-model.trim="userDetail.loginName" :disabled="userNameFlag"
                                      placeholder="请输入用户名"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="姓名：" prop="userName">
                            <el-input class="wh200" v-model.trim="userDetail.userName" placeholder="请输入姓名"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="inline" style="display:flex">
                        <el-form-item label="手机号码：" prop="telephone">
                            <el-input class="wh200" v-model.trim="userDetail.telephone"
                                      placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="部门：">
                            <select-tree
                                    ref="assDetailTree"
                                    :treeEdit="false"
                                    :strictly="false"
                                    node-key="id"
                                    :clearable="true"
                                    :nodeId="rootNode"
                                    :sourceData="dialogTreeBaseData"
                                    :formatTreeData="dialogJsonTree"
                                    @getValueMethod="clickAssDetailTree"
                                    @clearMethod="onDetailClear"
                            />
                        </el-form-item>
                    </div>
                    <div class="inline" style="display:flex">
                        <el-form-item label="角色：" prop="roleId">
                            <el-select class="wh200" v-model="userDetail.roleId" placeholder="请选择角色">
                                <el-option style="width: 200px"
                                           v-for="item in detailRoleList"
                                           :key="item.id"
                                           :label="item.roleName"
                                           :value="item.id"
                                           :disabled="!item.enable">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="工号：" prop="jobNumber">
                            <el-input class="wh200" v-model.trim="userDetail.jobNumber" placeholder="请输入工号"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="inline" style="display:flex">
                        <el-form-item label="状态：">
                            <el-select class="wh200" v-model="userDetail.statusId" placeholder="请选择状态">
                                <el-option
                                        class="wh200"
                                        v-for="item in detailStatusList"
                                        :key="item.id"
                                        :label="item.dictionaryName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="opendiaflag = false">取 消</el-button>
        <el-button type="primary" @click="resetPassword()" v-show="showRentPrise">重置密码</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>

      </span>
        </el-dialog>
    </div>
</template>
<script>

    import Tree from "@/components/common/Tree"
    import {Mixins} from '@/config/mixins/mixins'
    import {$http} from '@/config/api/axios'
    import {IsNull} from "@/config/validate/common.js";
    import SelectTree from "@/components/common/SelectTree";

    export default {
        name: 'userManager',
        mixins: [Mixins],
        components: {
            Tree,
            SelectTree,
        },
        data() {
            return {
                //用户名禁用标志
                userNameFlag: false,


                rootNode: 0,
                treeBaseData: [],
                myTreeBaseData: [],
                dialogTreeBaseData: [],
                innerJsonTree: {
                    id: "code",
                    label: 'departmentName',
                    pcode: 'parentCode',
                    code: 'code',
                },
                dialogJsonTree: {
                    id: "id",
                    label: 'departmentName',
                    pcode: 'parentCode',
                    code: 'code',
                },
                userDetail: {
                    id: '',
                    departmentId: '',
                    roleId: '',
                    loginName: '',
                    jobNumber: '',
                    userName: '',
                    telephone: '',
                    statusId: 1005001,
                },
                roleList: [],
                detailRoleList: [],
                showRentPrise: false,
                statusList: [],
                detailStatusList: [],
                tableTitle: [
                    {prop: "operation", label: '操作', width: '100px', align: 'center', show: true},
                    {prop: "userName", label: '姓名', width: '', align: 'left', show: true},
                    {prop: "loginName", label: '用户名', width: '', align: 'left', show: false},
                    {prop: "roleName", label: '角色名称', width: '', align: 'left', show: true},
                    {prop: "departmentName", label: '部门', width: '', align: 'left', show: true},
                    {prop: "telephone", label: '手机号码', width: '', align: 'center', show: false},
                    {prop: "statusName", label: '状态', width: '60px', align: 'center', show: false},
                    {prop: "lastLoginTime", label: '末次登录时间', width: '160px', align: 'center', show: true},
                    {prop: "createUserName", label: '创建人', width: '80px', align: 'center', show: false},
                    {prop: "createTime", label: '创建时间', width: '160px', align: 'center', show: true},
                ],
                tableData: [],
                keyword: '',
                roleId: 0,
                departmentCode: '',
                status: 0,
                pageSize: 20, //条数
                pageNumber: 1, //页数
                pagetotal: 0, //总页数
                title: '用户信息',
                opendiaflag: true,
                labelPosition: 'right',
                rules: {
                    roleId: [
                        {required: true, message: '角色不能为空', trigger: 'blur'},
                    ],
                    loginName: [
                        {required: true, message: '用户名不能为空', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度不超过20个字符', trigger: 'blur'},
                        {pattern: /^[A-Za-z0-9]+$/, message: "需为数字与字母", trigger: 'blur'}
                    ],
                    jobNumber: [
                        {min: 1, max: 10, message: '长度不超过10个字符', trigger: 'blur'},
                        {pattern: /^[A-Za-z0-9]+$/, message: "需为数字与字母", trigger: 'blur'}
                    ],
                    userName: [
                        {required: true, message: '用户名不能为空', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度不超过20个字符', trigger: 'blur'},
                    ],
                    telephone: [
                        {pattern: /^1[3456789]\d{9}$/, message: "请正确输入手机号码", trigger: 'blur'}
                    ]
                },
                tableDragVisible: false,
            }
        },
        watch: {},
        methods: {
            onClear() {
                this.departmentCode = ""
            },
            clickAssInnerTree(data) {
                this.$refs.assInnerTree.setLabel(data.label);
                this.departmentCode = data.id;
            },
            onDetailClear() {
                this.userDetail.departmentId = "";
            },
            clickAssDetailTree(data) {
                this.userDetail.departmentId = data.id;
                this.$refs.assDetailTree.setLabel(data.label)
            },
            resetPassword() {
                this.$confirm('重置后密码将变为111111，确认要重置吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: ''
                }).then(() => {
                    let param = {
                        userId: this.userDetail.id
                    }
                    $http("post", "user/resetPassword", param).then(res => {
                        if (res.status == 'SUCCESS') {
                            this.msgsuccess('重置成功');
                        } else {
                            this.msgerror(res.message);
                        }
                    });
                }).catch(() => {
                });
            },
            tableDragClose(visible, changedData) {
                this.tableDragVisible = visible;
                this.tableTitle = changedData ? JSON.parse(changedData) : this.tableTitle
            },
            search() {
                this.handleCurrentChange(1);
            },
            toModify(scope) {
                this.userNameFlag = true;
                this.opendiaflag = true;
                this.dialogTreeBaseData = JSON.parse(JSON.stringify(this.myTreeBaseData));
                this.$refs.ruleForm.resetFields();
                this.showRentPrise = true;
                this.userDetail.id = scope.row.id;
                this.userDetail.departmentId = scope.row.departmentId;
                this.userDetail.roleId = scope.row.roleId;
                this.userDetail.loginName = scope.row.loginName;
                this.userDetail.jobNumber = scope.row.jobNumber;
                this.userDetail.userName = scope.row.userName;
                this.userDetail.telephone = scope.row.telephone;
                this.userDetail.statusId = scope.row.statusId;
                this.$nextTick(() => {
                    this.$refs.assDetailTree.setLabel(scope.row.departmentName)
                });
            },
            toSave() {
                this.userNameFlag = false;
                this.opendiaflag = true;
                this.dialogTreeBaseData = JSON.parse(JSON.stringify(this.myTreeBaseData));
                this.$refs.ruleForm.resetFields();
                this.userDetail.id = '';
                this.userDetail.departmentId = '';
                this.userDetail.statusId = 1005001;
                this.showRentPrise = false;
            },
            del(scope) {
                this.$confirm('删除后不能恢复，确认要删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let param = {
                        userId: scope.row.id
                    }
                    $http("post", "user/deleteEntity", param).then(res => {
                        if (res.status == 'SUCCESS') {
                            this.msgsuccess(res.message);
                            if (this.tableData.length == 1 && this.pageNumber > 1) {
                                this.pageNumber--;
                            }
                            this.getPageData();
                        } else if (res.status == 'ERROR') {
                            this.msgerror(res.message);
                        }
                    });
                }).catch(() => {

                });
            },
            submitForm(ref) {
                this.$refs[ref].validate((valid) => {
                    if (valid) {
                        let param = {
                            id: this.userDetail.id,
                            departmentId: IsNull(this.userDetail.departmentId) ? 0 : this.userDetail.departmentId,
                            roleId: this.userDetail.roleId,
                            loginName: this.userDetail.loginName,
                            jobNumber: this.userDetail.jobNumber,
                            userName: this.userDetail.userName,
                            telephone: this.userDetail.telephone,
                            statusId: this.userDetail.statusId,
                        };
                        if (IsNull(param.id)) {
                            $http("post", "user/saveEntity", param).then(res => {
                                if (res.status == 'SUCCESS') {
                                    this.opendiaflag = false;
                                    this.msgsuccess('新增成功，默认密码为：111111');
                                    this.getPageData();
                                } else {
                                    this.msgerror(res.message);
                                }
                            });
                        } else {
                            $http("post", "user/updateEntity", param).then(res => {
                                if (res.status == 'SUCCESS') {
                                    this.opendiaflag = false;
                                    this.msgsuccess(res.message);
                                    this.getPageData();
                                } else {
                                    this.msgerror(res.message);
                                }
                            });
                        }
                    }
                });

            },
            getRoleList() {
                $http("get", "role/getAll", null).then(res => {
                    if (res.status == "SUCCESS") {
                        this.detailRoleList = res.data;
                        this.roleList = JSON.parse(JSON.stringify(res.data));
                    } else if (res.status == "NORESOURCES") {

                    } else {
                        this.msgerror(res.message);
                    }
                    this.roleList.unshift({
                        "id": 0,
                        "roleName": "全部"
                    });
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleCurrentChange(val) {
                this.pageNumber = val;
                this.getPageData();
            },
            getStatusList() {
                let param = {
                    typeId: 1005
                }
                $http("get", "dictionary/listDictionaryByTypeId", param).then(res => {
                    if (res.status == "SUCCESS") {
                        this.detailStatusList = res.data;
                        this.statusList = JSON.parse(JSON.stringify(res.data));
                    } else if (res.status == "NORESOURCES") {

                    } else {
                        this.msgerror(res.message);
                    }
                    this.statusList.unshift({
                        "id": 0,
                        "dictionaryName": "全部"
                    });
                });
            },
            getDepartmentList() {
                let param = {
                    isAll: true
                }
                $http("get", "department/listDepartments", param).then(res => {
                    if (res.status == "SUCCESS") {
                        this.treeBaseData = res.data;
                    } else if (res.status == "NORESOURCES") {

                    } else {
                        this.msgerror(res.message);
                    }
                });
            },
            getDialogDepartmentList() {
                $http("get", "department/listDepartments", null).then(res => {
                    if (res.status == "SUCCESS") {
                        this.myTreeBaseData = res.data;
                    } else if (res.status == "NORESOURCES") {

                    } else {
                        this.msgerror(res.message);
                    }
                });
            },
            getPageData() {
                let param = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    keyword: this.keyword,
                    roleId: this.roleId === 0 ? null : this.roleId,
                    departmentCode: this.departmentCode,
                    status: this.status === 0 ? null : this.status,
                }
                $http("get", "user/pageList", param).then(res => {
                    if (res.status == "SUCCESS") {
                        this.tableData = res.data;
                        this.pagetotal = res.count;
                    } else if (res.status == "NORESOURCES") {
                        this.tableData = [];
                        this.pagetotal = 0;
                    } else {
                        this.msgerror(res.message);
                    }
                });
            },
        },

        created() {
        },
        mounted() {
            this.getRoleList();
            this.getStatusList();
            this.getDepartmentList();
            this.getDialogDepartmentList();
            this.getPageData()
            this.$nextTick(() => {
                this.opendiaflag = false;
            });
        },
        activated() {
            this.$refs.singleTable.doLayout() // 路由切换时对table重新布局啊
        },
    }
</script>

<style lang="less">
    .usermanager {
        width: 100%;
        height: 100%;
        margin-bottom: 10px;
        display: flex;
        position: relative;
    }
</style>